import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
// import Edit from "@material-ui/icons/Edit";
import { ArrowRight } from "@phosphor-icons/react";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Skeleton from "@mui/material/Skeleton";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { Domain } from "Domain";
// import { Close } from "@material-ui/icons";

const useStyles = makeStyles(styles);

export default function CustomTable({
  tableHead,
  tableData,
  tableHeaderColor,
  setEdit,
  loading,
  noAction,
  Images,
}) {
  const classes = useStyles();
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}

        <TableBody>
          {loading
            ? Array.from({ length: 5 }).map((_, rowIndex) => (
                <TableRow key={rowIndex} className={classes.tableBodyRow}>
                  {Array.from({ length: tableHead ? tableHead.length : 4 }).map(
                    (_cell, cellIndex) => (
                      <TableCell className={classes.tableCell} key={cellIndex}>
                        <Skeleton
                          height={24}
                          width={cellIndex === 0 ? 42 : "72%"}
                        />
                      </TableCell>
                    )
                  )}
                </TableRow>
              ))
            : tableData.map((prop, key) => {
                return (
                  <TableRow key={key} className={classes.tableBodyRow}>
                    {Images ? (
                      <>
                        {prop.Image && (
                          <img
                            className={classes.tableCellImage}
                            src={Domain + prop.Image}
                            alt=".."
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {Object.values(prop).map((props, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <b>{props}</b>
                        </TableCell>
                      );
                    })}
                    {noAction ? (
                      <></>
                    ) : (
                      <>
                        {" "}
                        <Button
                          onClick={() => setEdit(prop.Id)}
                          color="primary"
                        >
                          <ArrowRight size={18} weight="bold" />
                        </Button>
                      </>
                    )}
                  </TableRow>
                );
              })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  setEdit: PropTypes.any,
  setDelete: PropTypes.any,
  loading: PropTypes.bool,
  noAction: PropTypes.bool,
  Images: PropTypes.bool,
};
